import { render, staticRenderFns } from "./ModalDocumentAliasName.vue?vue&type=template&id=46f2ed44&"
import script from "./ModalDocumentAliasName.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentAliasName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports